const MADINA = '/api/v1/madina';

export const MADINA_HEALTH = `${MADINA}/health`;
export const MADINA_BRANCHES = `${MADINA}/branches`;
export const MADINA_CATALOG_HOME = `${MADINA}/catalog/home`;
export const MADINA_CATALOG_CATEGORIES = `${MADINA}/catalog/categories`;
export const MADINA_CATALOG_PRODUCTS = `${MADINA}/catalog/products`;
export const MADINA_SEARCH_PRODUCTS = `${MADINA}/search/products`;
export const MADINA_SEARCH_SUGGESTIONS = `${MADINA}/search/suggestions`;
export const MADINA_CART = `${MADINA}/cart`;
export const MADINA_CART_ITEMS = `${MADINA}/cart/items`;
export const MADINA_CART_REVALIDATE = `${MADINA}/cart/revalidate`;
export const MADINA_CHECKOUT = `${MADINA}/checkout`;
export const MADINA_CHECKOUT_PAYMENT_METHODS = `${MADINA}/checkout/payment-methods`;
export const MADINA_CHECKOUT_PAYMENT_CONFIG = `${MADINA}/checkout/payment-config`;
export const MADINA_ORDERS = `${MADINA}/orders`;
/** ERP OnionPay webhook (POST only). OnionPay → server marks order paid. Never use as checkout `callback_url`. */
export const MADINA_ERP_ONIONPAY_WEBHOOK = `${MADINA}/payment/onionpay/callback`;

export const madinaOrderPath = (orderId: number | string) => `${MADINA_ORDERS}/${orderId}`;
export const madinaOrderPaymentStatusPath = (orderId: number | string) =>
  `${MADINA_ORDERS}/${orderId}/payment-status`;
export const madinaOrderPaymentVerifyPath = (orderId: number | string) =>
  `${MADINA_ORDERS}/${orderId}/payment/verify`;
export const madinaOrderTrackingPath = (orderId: number | string) => `${MADINA_ORDERS}/${orderId}/tracking`;
export const madinaOrderReceiptPath = (orderId: number | string) => `${MADINA_ORDERS}/${orderId}/receipt`;
export const madinaOrderReceiptPdfPath = (orderId: number | string) => `${MADINA_ORDERS}/${orderId}/receipt/pdf`;
export const madinaOrderCancelPath = (orderId: number | string) => `${MADINA_ORDERS}/${orderId}/cancel`;
export const madinaCartItemPath = (cartItemId: number | string) => `${MADINA_CART_ITEMS}/${cartItemId}`;
export const madinaProductDetailPath = (productId: number | string) =>
  `${MADINA_CATALOG_PRODUCTS}/${productId}`;
